const { createContext } = require("react");

export const VishcorpContext = createContext();
